import { FC, useState } from "react";

interface Props {
    currentLocale: string
    currentCountry?: string
    onRefresh: (newLocale: string, newCountry?: string) => void
  }

declare const Five9SocialWidget : any;

export const LocaleInput: FC<Props> = ({ currentLocale, currentCountry, onRefresh }) => {
    const refresh = () => {
        Five9SocialWidget.removeWidget();
        onRefresh(currentLocale, currentCountry);
    };

    const onLocaleChange = (event: any) => {
        currentLocale = event.target.value;
    }

    const onCountryChange = (event: any) => {
        currentCountry = event.target.value;
    }

    return (
        <>
            <div>
                <label>Locale: </label>
                <input type="text" value={currentLocale} onChange={onLocaleChange}></input>
                <br />
                <label>NFR Country, ISO2 or ISO3 code:</label>
                <input type="text" value={currentCountry} onChange={onCountryChange}></input>
                <br />
                <br />
                <button onClick={refresh}>Reload Chat</button>
            </div>
        </>
    );
};